<template lang="html">
  <div id="update-user-profile" class="row page">
    <div v-if="loader" class="loader"></div>
    <div class="col-lg-3"></div>
    <div class="col-lg-9">
      <form @submit.prevent="updateUserProfile" novalidate>
      <div class="update-user-container row">
        <div class="col-md-12 user-notification-container">
          <div class="row">
            <div class="col-lg-6 text-left">
              <h3>
                {{translation.notifications.notifHeader + ' ' + translation.notifications.byEmail}}:
                <span class="text-checkbox" v-if="users.wsNotification">{{translation.notifications.on}}</span>
                <span class="text-checkbox" v-else>{{translation.notifications.off}}</span>
              </h3>
            </div>
            <div class="col-lg-6 user-checkbox text-right">
              <div>
                <label class="switch">
                  <input type="checkbox" id="byEmail" v-model="users.wsNotification" @change="changedForm">
                  <span class="slider round"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="user-info-container">
          <div class="user-profile-header">
            <h3>{{translation.profile.previewProfile}}</h3>
          </div>
          <div class="col-lg-6">
            <div class="update-user-img">
              <div class="row">
                <div class="col-md-6 text-position">
                  <div v-if="this.previewImage != null">
                    <img v-bind:src="this.previewImage" class="uploading-image img-responsive img-circle" v-model="users.avatar"/>
                  </div>
                  <div v-else>
                    <img class="uploading-image img-responsive img-circle" src="../../assets/img/user-home-icon-default.svg" alt="Default Image">
                  </div>
                </div>
                <div class="col-md-6">
                  <div id="upload_image">
                    <div class="input-file-row-1">
                      <div class="upload-file-container">
                        <div class="text-success" v-show="uploadMessage">{{uploadMessage}}</div>
                        <div class="text-success" v-show="removeMessage">{{removeMessage}}</div>
                        <div class="upload-file-container-text">
                          <label class="btn add-user-image" for="my-file-selector" id="userAvatar" accept="image/*" @change='uploadImage'>
                              <input id="my-file-selector" type="file"  style="display:none;">
                              {{translation.button.addImage}}
                          </label>
                          <label class="btn remove-user-image" @click='removeImage'>
                              {{translation.button.removeImage}}
                          </label>
                       </div>
                     </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="row">
              <div class="col-md-6">
                <p v-if="errors.length" class="text-left text-danger">
                  <b>{{translation.registration.correct}}</b>
                  <ul class="list-group">
                    <li class="text-danger text-left list-group-item list-group-item-light" v-for="error in errors">{{ error }}</li>
                  </ul>
                </p>
                <p v-if="update" class="text-left text-success">
                  <b>{{translation.registration.updateCorrect}}</b>
                </p>
                <p class="text-left">
                  <span>{{translation.registration.requiredField}}</span>
                  <span class="text-danger">{{translation.registration.requiredSymbol}}</span>
                  <span>{{translation.registration.areRequired}}</span>
                </p>
              </div>
              <div class="col-md-6 text-right">
                <label id="language-label">{{translation.registration.language}}</label>
                <select id="select-language" v-model="defaultLang" @change="setLanguage">
                  <option class="language-option" v-for="language in languages" :value="language.value">
                    {{language.text}}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-lg-4">

          </div>
          <div class="col-lg-8">
            <div class="row">
              <div class="col-lg-6">
                <div class="form-group text-left">
                  <input type="text" @change="changedForm" class="form-control" name="update-firstName" v-model="users.firstName" :placeholder="translation.registration.firstName + translation.registration.requiredSymbol">
                  <label for="update-firstName">{{translation.registration.firstName + translation.registration.requiredSymbol}}</label>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group text-left">
                  <input type="text" @change="changedForm" class="form-control" name="update-lastName" v-model="users.lastName" :placeholder="translation.registration.lastName + translation.registration.requiredSymbol">
                  <label for="update-lastName">{{translation.registration.lastName + translation.registration.requiredSymbol}}</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <div class="form-group text-left">
                  <input type="email" @change="changedForm" class="form-control"
                         name="user-update-email" v-model="users.email" :placeholder="translation.registration.email + translation.registration.requiredSymbol">
                  <label for="user-update-email">{{translation.registration.email + translation.registration.requiredSymbol}}</label>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group text-left">
                  <input type="text" @change="changedForm" class="form-control" name="update-phoneNumber" v-model="users.phoneNumber" :placeholder="translation.registration.phoneNumber">
                  <label for="update-phoneNumber">{{translation.registration.phoneNumber}}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-sm-4">
                <div class="form-group text-left">
                  <input type="text" @change="changedForm" class="form-control" name="update-country" v-model="users.country" :placeholder="translation.updateProfile.country">
                  <label for="update-country">{{translation.updateProfile.country}}</label>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group text-left">

                  <input type="text" @change="changedForm" class="form-control" name="update-city" v-model="users.city" :placeholder="translation.updateProfile.city">
                    <label for="update-city">{{translation.updateProfile.city}}</label>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group text-left">
                  <input type="text" @change="changedForm" class="form-control" name="update-neighborhood" v-model="users.neighborhood" :placeholder="translation.updateProfile.neighborhood">
                  <label for="update-neighborhood">{{translation.updateProfile.neighborhood}}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="">
          <div class="row">
            <div class=" update-user-password">
              <div class="user-profile-header">
                <h3>{{translation.updateProfile.passwordChange}}</h3>
              </div>
              <div class="col-md-6">
                <div class="form-group text-left">
                  <input type="password" @change="changedForm" class="form-control" name="user-old-password" v-model="users.oldPassword" :placeholder="translation.updateProfile.oldPassword + translation.registration.passwordLenth + translation.registration.requiredSymbol">
                  <label for="user-old-password">{{translation.updateProfile.oldPassword + translation.registration.passwordLenth + translation.registration.requiredSymbol}}</label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group text-left">
                  <input type="password" @change="changedForm" class="form-control" name="user-new-password" v-model="users.newPaswword" :placeholder="translation.updateProfile.newPaswword + translation.registration.requiredSymbol + translation.registration.passwordLenth">
                  <label for="user-new-password">{{translation.updateProfile.newPaswword + translation.registration.passwordLenth + translation.registration.requiredSymbol}}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
            <div class="user-profile-header">
              <h3 @click="deleteProfile">{{translation.profile.deleteProfile}}</h3>
            </div>
        </div>

      </div>
      <div class="edit-user-profile">
        <div class="middle-update-profile">
          <button type="submit" class="btn update-user-profile-btn">{{translation.button.update}}</button>
        </div>
          <div class="small-update-profile">
            <button type="submit" class="btn"><img src="../../assets/img/icons/mobile-save-icon.svg" alt="edti mobile icon"></button>
          </div>
      </div>
      </form>
      <div v-if='showUnsaveModal' class="modal text-left">
        <div class="modal-content modal-small" >
          <div class="modal-header">
            <h3>{{translation.modalText.modalHeader}}</h3>
            <span class="close-modal" @click="hideUnsaveModal">&times;</span>
          </div>
          <div class="modal-body modal-body-small">
            <p>{{translation.modalText.userWarning}}</p>
            <p>{{translation.modalText.modalQuestion}}</p>
          </div>
          <div class="modal-footer">
            <button class=" modal-button-remove  close-modal-button" @click="hideUnsaveModal">{{translation.button.noDelete}}</button>
            <button class=" modal-button-add" type="submit" @click="updateUserProfile">{{translation.modalText.modalSaveButton}}</button>
          </div>
        </div>

      </div>
      <div v-if='deleteProfileModal' class="modal text-left">
        <div class="modal-content modal-small" >
          <div class="modal-header">
            <h3>{{translation.modalText.modalHeader}}</h3>
            <span class="close-modal" @click="noDeleteProfile">&times;</span>
          </div>
          <div class="modal-body modal-body-small">
            <p>{{translation.profile.ifDelete}}</p>
            <p>{{translation.modalText.deleteProfile}}</p>
          </div>
          <div class="modal-footer">
            <button class="modal-button-remove  close-modal-button" @click="deleteUserProfile">{{translation.modalText.yes}}</button>
            <button class="modal-button-add" @click="noDeleteProfile">{{translation.modalText.no}}</button>

          </div>
        </div>

      </div>
        <Footer/>
    </div>
  </div>
</template>
<script>
import Footer from '../../components/Footer.vue';
export default {
  data(){
    return {
      translation: null,
      previewImage:null,
      update: false,
      loader: false,
      languages: message.flags.flag,
      uploadPercentage: 0,
      uploadMessage: '',
      removeMessage: '',
      errors: [],
      defaultLang: localStorage.getItem('language'),
      users: [],
      chenagedInput: false,
      showUnsaveModal: false,
      userPath: null,
      deleteProfileModal: false
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.chenagedInput) {
      this.showUnsaveModal = true;
      this.userPath = this.$router.history.pending.fullPath;
    }else {
      this.showUnsaveModal = false;
      next();
    }
  },
  components:{
    Footer
  },
  created(){
    this.$bus.$on('language', () => {
      this.translation = window.message;
    });
    this.translation = window.message;
    this.loader = true;
    var self = this;
    if (localStorage.getItem('userLoggedIn') != undefined) {
      if ( localStorage.getItem('userLoggedIn') == true
      || localStorage.getItem('userLoggedIn') == 'true') {
        axios.get('get-user-profile')
        .then(function(response){
          self.loader = false;
          self.users = response.data.result
          self.oldUser = response.data.result
          if (self.users.avatar) {
            self.previewImage = self.users.avatar;
          }
          if (self.users.phoneNumber == null || self.users.phoneNumber == 'null') {
            self.users.phoneNumber = '';
          }
          if (self.users.country == null || self.users.country == 'null') {
            self.users.country = '';
          }
          if (self.users.city == null || self.users.city == 'null') {
            self.users.city = '';
          }
          if (self.users.neighborhood == null || self.users.neighborhood == 'null') {
            self.users.neighborhood = '';
          }
        })
        .catch(err => err)
      }
    }else {
      self.$router.push({ name: 'home', params: { lang: window.lang } })
    }
  },
  methods: {
    changedForm: function(){
      this.chenagedInput = true;
    },
    validate: function (e) {
      var checkPhone = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g;
      this.errors = [];
      if (!this.users.email) {
        this.errors.push(
          this.translation.registration.field + ' "' +
          this.translation.registration.email + '" ' +
          this.translation.registration.required
        );
      } else if (!this.validEmail(this.users.email)) {
        this.errors.push(this.translation.registration.validEmail);
      }
      if (!this.users.firstName) {
        this.errors.push(
          this.translation.registration.field + ' "' +
          this.translation.registration.firstName + '" ' +
          this.translation.registration.required
        );
      }
      if (!this.users.lastName) {
        this.errors.push(
          this.translation.registration.field + ' "' +
          this.translation.registration.lastName + '" ' +
          this.translation.registration.required
        );
      }
      if (this.users.phoneNumber != '' && this.users.phoneNumber != null && this.users.phoneNumber != 'null') {
        if (!this.users.phoneNumber.match(checkPhone)) {
          this.errors.push(
            this.translation.updateProfile.validPhoneNumber
          )
        }
      }
      if (this.users.wsNotification) {
        this.users.wsNotification = 1;
      }else {
        this.users.wsNotification = 0;
      }
      if (this.users.mNotification) {
        this.users.mNotification = 1;
      }else {
        this.users.mNotification = 0;
      }
      if (!this.errors.length) {
        return true;
      }
    },
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    hideUnsaveModal: function(){
      this.showUnsaveModal = false;
      this.nextPage();
    },
    nextPage: function(){
      this.chenagedInput = false;
      if (this.userPath) {
        this.$router.push(this.userPath);
      }
    },
    updateUserProfile: function (e){
      this.hideUnsaveModal();
      if (this.validate(e)) {
        this.loader = true;
        this.users.language = this.defaultLang;
        var formData = this.toFormData(this.users);
        var self = this;
        axios.post('user-update-profile', formData)
        .then(function(response){
          self.loader = false;
          self.update = true;
          self.chenagedInput = false;
          if (self.userPath) {
            self.$router.push(self.userPath);
          }
          if (response.data.success && response.data.result.serverMessage) {
            var checkError = response.data.result.serverMessage;
            if (checkError == 'emptyEmail') {
              self.errors.push(self.translation.serverError.emptyEmail);
            }else if (checkError == 'invalidEmail') {
              self.errors.push(self.translation.serverError.invalidEmail);
            }else if (checkError == 'busyEmail') {
              self.errors.push(self.translation.serverError.busyEmail);
            }else if (checkError == 'invalidFirstName') {
              self.errors.push(self.translation.serverError.invalidFirstName);
            }else if (checkError == 'firstNameLengt') {
              self.errors.push(self.translation.serverError.firstNameLengt);
            }else if (checkError == 'firstNameSymbol') {
              self.errors.push(self.translation.serverError.firstNameSymbol);
            }else if (checkError == 'invalidLastName') {
              self.errors.push(self.translation.serverError.invalidLastName);
            }else if (checkError == 'LastNameLengt') {
              self.errors.push(self.translation.serverError.LastNameLengt);
            }else if (checkError == 'LastNameSymbol') {
              self.errors.push(self.translation.serverError.LastNameSymbol);
            }else if (checkError == 'validEmail') {
              self.errors.push(self.translation.serverError.validEmail);
            }else if (checkError == 'emptyPassword') {
              self.errors.push(self.translation.serverError.emptyPassword);
            }else if (checkError == 'passwordLengt') {
              self.errors.push(self.translation.serverError.passwordLengt);
            }else if (checkError == 'wrongEmail') {
              self.errors.push(self.translation.serverError.wrongEmail);
            }else if (checkError == 'wrongPassword') {
              self.errors.push(self.translation.serverError.wrongPassword);
            }else if (checkError == 'oldPassword') {
              self.errors.push(self.translation.serverError.oldPassword);
            }else if (checkError == 'newPassword') {
              self.errors.push(self.translation.serverError.newPassword);
            }
          }else {
            self.$bus.$emit('logged', true)
            self.users;
          }
        })
        .catch(err => err)
      }
    },
    toFormData: function (obj){
      var form_data = new FormData();
      for (var key in obj) {
        form_data.append(key,obj[key]);
      }
      return form_data;
    },
    uploadImage(e){
      this.loader = true;
      const image = e.target.files[0];
      var self = this;
      let fd= new FormData();
      const reader = new FileReader();
      if (image != undefined) {
        if (image.name.match(/.(jpg|jpeg|png|gif)$/i)) {
          reader.readAsDataURL(image);
          reader.onload = e =>{
            this.previewImage = e.target.result;
          };
          fd.append('images[]', image)
          fd.append('createFolder', 'user')
          fd.append('petNumber', '')
          axios.post('upload-image', fd,{
            onUploadProgress: function( progressEvent ) {
              self.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total) * 100 ) );
            }
          })
          .then(resp => {
            self.loader = false;
             self.users.avatar = resp.data
             self.removeMessage = '';
             self.uploadMessage = self.translation.registration.imageUpload;
             self.$bus.$emit('userThumb', true)
          })
        }else {
          self.errors.push(self.translation.errors.imageError)
        }
      }
      e.preventDefault();
    },
    deleteProfile(){
      this.deleteProfileModal = true;
    },
    noDeleteProfile(){
      this.deleteProfileModal = false;
    },
    deleteUserProfile(){
      var self = this;
      self.loader = true;
      axios.post('delete-user-profile')
      .then(function(response){
        self.loader = false;
        self.$router.push('/logout')
      })
      .catch(err => err)
    },
    removeImage(){
      this.loader = true;
      var self = this;
      axios.post('delete-image')
      .then(function(){
        self.loader = false;
        self.previewImage = null;
        self.uploadPercentage = 0;
        self.uploadMessage = '';
        self.removeMessage = self.translation.registration.removeUpload;
        self.$bus.$emit('userThumb', true)
      })
    },
    setLanguage: function(){
      localStorage.setItem('language', this.defaultLang);
      this.$bus.$emit('language',true)
    }
  }
}
</script>
<style>
  #update-user-profile{

    background-image: url('../../assets/img/backgrounds/background-after-login.jpg');
    background-repeat:no-repeat;
    max-width:inherit;

    background-position: center;
    background-size: cover;
    min-height: 100vh;
  }
  #update-user-profile .footer{
    color: #707070;
    margin-bottom: 3.5em;
  }
  #update-user-profile .update-user-container{
    margin-top: 5em;
  }
  #update-user-profile .user-notification-container{
    background: #fff;
    -webkit-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
    -moz-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
    box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
    border-radius: .75em;
    padding: 1em;
    position: relative;
  }
  #update-user-profile .user-info-container{
    background-color: #fff;
    min-height: 100%;
    -webkit-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
    -moz-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
    box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
    border-radius: .75em;
    min-height: 35em;
  }
  #update-user-profile  .update-user-password{
    background-color: #fff;
    min-height: 100%;
    -webkit-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
    -moz-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
    box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
    border-radius: .75em;
    min-height: 15em;
    margin-bottom: 5em;
  }
  #update-user-profile .user-notification-container h3{
    margin: 0;
    color: #3057B0;
    padding-top: .3em;
  }
  #update-user-profile .update-user-img .text-position{
    text-align: left;
  }
  #update-user-profile .update-user-img img {
    border: 2px solid  #3057B0;
    display: inline-block;
    width: 10em;
    height: 10em;
  }
  #update-user-profile #upload_image{
    margin-top: 3em;
  }
  #update-user-profile .user-profile-header{
    background: #EEEEEE;
    border-top-left-radius: .75em;
    border-top-right-radius: .75em;
    margin-top: 2em;
    -webkit-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
    -moz-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
    box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
    border-top-left-radius: .75em;
    border-top-right-radius: .75em;
    text-align: left;
  }
  #update-user-profile #upload_image label,
  #update-user-profile #language-label{
    display: block;
  }
  #update-user-profile #select-language{
  border: none;
  background: none;
  border-radius: 5em;
  padding: 5px;
  color: #FDD84C;
  font-family: 'Montserrat-Bold', sans-serif;
  border: none;
  outline: none;
  scroll-behavior: smooth;
}
  #update-user-profile #select-language {
    background: #3057B0;
    color: #FFFFFF;
  }
  .language-option{
    color:#fff;
    background-color: #3057B0;
  }
  #update-user-profile #select-language{
      -webkit-appearance: none;
      appearance: none;
  }

  #update-user-profile #upload_image .add-user-image{
    background: #3057B0;
    padding: .5em;
    padding-left: 1em;
    margin-bottom: 1em;
    padding-right: 1em;
    border-radius: 2em;
    color: #fff;
  }
  #update-user-profile #upload_image .remove-user-image{
    background: #fff;
    border: 1px solid #3057B0;
    padding: .5em;
    padding-left: 1em;
    padding-right: 1em;
    border-radius: 2em;
    color: #3057B0;
  }
  #update-user-profile .user-profile-header h3{
    border-bottom: 1px solid #707070;
    padding: 1em;
    color: #3057B0;
  }
  #update-user-profile .user-notification-container  .user-checkbox div{
    position: absolute;
    right: 1em;
    z-index: 2;
  }
  #update-user-profile .user-notification-container .text-checkbox{
    color: #FE7154;
  }
#update-user-profile .switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
  display: block;
}
#update-user-profile .switch #byEmail {
  opacity: 0;
  width: 0;
  height: 0;
}
#update-user-profile .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}
#update-user-profile .slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

#update-user-profile #byEmail:checked + .slider {
  background-color: #3057B0;
}

#update-user-profile #byEmail:focus + .slider {
  box-shadow: 0 0 1px #3057B0;
}

#update-user-profile #byEmail:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

#update-user-profile .slider.round {
  border-radius: 34px;
}
#update-user-profile .slider.round:before {
  border-radius: 50%;
}
#update-user-profile .form-group{
  position: relative;
  margin-top: 2em;
}
#update-user-profile input[type=text],
#update-user-profile input[type=password],
#update-user-profile input[type=email]
{
 color: #707070!important;
 background: none!important;
 border: none!important;
 border-radius: 0!important;
 outline: none!important;
 border-bottom: 2px solid #707070!important;
 width: 100%;
 outline: none!important;
 box-shadow: none;
}
#update-user-profile label {
 display: none;
}
#update-user-profile input[type=text]:focus,
#update-user-profile input[type=password]:focus,
#update-user-profile input[type=email]:focus
{
 border-bottom: 2px solid #3057B0!important;
 outline:0px !important;
 -webkit-appearance:none;
 box-shadow: none !important;
}
#update-user-profile input[type=text]:focus + label ,
#update-user-profile input[type=password]:focus + label,
#update-user-profile input[type=email]:focus + label
{
  display: block;
  position: absolute;
  bottom: 2em;
  color: #212121!important;
  font-size: 1em;
}
#update-user-profile input[type=text]:focus::-webkit-input-placeholder,
#update-user-profile input[type=password]:focus::-webkit-input-placeholder,
#update-user-profile input[type=email]:focus::-webkit-input-placeholder
{
 color:transparent;
}
#update-user-profile input[type=text]::-moz-placeholder
#update-user-profile input[type=password]:focus::-moz-placeholder
#update-user-profile input[type=email]:focus::-moz-placeholder {
 color:transparent;
}
#update-user-profile input[type=text]:focus::-moz-placeholder
#update-user-profile input[type=password]:focus::-moz-placeholder
#update-user-profile input[type=email]:focus::-moz-placeholder {
  color:transparent;
}
#update-user-profile input[type=text]:focus::-ms-input-placeholder
#update-user-profile input[type=password]:focus::-ms-input-placeholder
#update-user-profile input[type=email]:focus::-ms-input-placeholder {
 color:transparent;
}
.list-group-item{
 border: none;
 background: none;
 padding-left: 0;
 font-size: .8em;
}
#update-user-profile .requiredField input{
 border-bottom: 2px solid #F82727!important;
}
#update-user-profile .requiredField label{
 color: #F82727!important;
 opacity: 1;
}
#update-user-profile .edit-user-profile {
  position: fixed;
  bottom: 50px;
  left: 0;
  right: 0;
  z-index: 1;
}
#update-user-profile .edit-user-profile .update-user-profile-btn{
  display: inline-block;
  background: #FE7154;
  padding: .5em;
  padding-left: 1em;
  padding-right: 1em;
  border-radius: 2em;
  color: #fff;
}
#update-user-profile .edit-user-profile .small-update-profile {
  display: none;
}
#update-user-profile ::placeholder {
  color: #707070;
  opacity: 1;
}
#update-user-profile :-ms-input-placeholder {
  color: #707070;
  opacity: 1;
}
#update-user-profile ::-ms-input-placeholder {
  color: #707070;
  opacity: 1;
}
@media (max-width: 1024px) {
  #update-user-profile{
    margin-bottom: 9em;
  }
  #update-user-profile .edit-user-profile .update-user-profile-btn{
    display: none;
  }
  #update-user-profile .edit-user-profile{
    position: fixed;
    display: block;
    bottom: 9em;
    right: 0;
    z-index: 1;
    text-align: right;
  }
  #update-user-profile .edit-user-profile button {
    background: transparent;
  }
  #update-user-profile .edit-user-profile .small-update-profile{
    display: block;
  }
  #update-user-profile .user-notification-container .user-checkbox div{
    position: relative;
    margin-left: 1em;
  }
  #update-user-profile .user-info-container{
    min-height: 45em;
  }
}
@media (max-width: 768px) {
  #update-user-profile .update-user-img .text-position{
    text-align: center;
  }
  #update-user-profile .edit-user-profile{
    bottom: 7em;
    padding: 0;
  }
}
</style>
